import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

import { RVNestedRoutingPage } from "@regal-voice/ui";
import { AppPagePaths } from "App/routes/paths";
import { orchestrationPathResources } from "Pages/orchestration/Pages/orchestrationPaths";
import { useFlags } from "Services/FeatureFlagService";
import { selectIsDuplicateForm } from "Services/state/ivr/IVRNodeDataStateSlice";

export default function IVRRouter(): JSX.Element {
    const { ivrPage } = useFlags();
    const { pathname } = useLocation();

    // we manage the redirection here react router replace function
    // retriggers the NestedRoutes component. This differers from the
    // direct useage of the history api.
    const isDupe = useSelector(selectIsDuplicateForm);
    const hasDupePath = pathname.includes("duplicate");

    if (!isDupe && hasDupePath) {
        return <Navigate to={`${AppPagePaths.settings}/${orchestrationPathResources.ivrs}/new`} />;
    }

    if (!ivrPage) {
        return <Navigate to={AppPagePaths.settings} />;
    }

    return <RVNestedRoutingPage />;
}
